import { __decorate } from "tslib";
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { AccountApi } from '@/api/account/AccountApi';
import { ACCOUNT_LS_KEY } from '@/helpers/consts';
import { safeSetItem } from '@/helpers/storage';
const EMPTY_ACCOUNT_TITLES = {
    account: {
        id: '',
        internal_name: '',
        name: '',
        url_builder_support: false,
        client_api_support: false,
        confirm_remote_slots_support: false,
        plan: '',
        licence: '',
        current_month_email_count: 0,
        current_month_sms_count: 0,
        sub_accounts: [],
        geo_scope: '',
        service_point_support: false,
        country_iso_code: '',
        calculate_route_for_branches_booking: false,
        salesforce_support: false,
        hubspot_support: false,
        microsoft_dynamics_support: false,
        prequestion_support: true,
    },
    countries: [],
    questions_flows: [],
    appointment_attributes: [],
    cancellation_origins: [],
    cancellation_reasons: [],
    unavailability_titles: [],
};
let CommonStore = class CommonStore extends VuexModule {
    isFixedBgOpen = false;
    hideBgStatus = true;
    progressBarKey = 1;
    accountData = EMPTY_ACCOUNT_TITLES;
    skills = [];
    setAccountTitles(titles) {
        this.accountData = titles;
        safeSetItem(ACCOUNT_LS_KEY, JSON.stringify(titles));
    }
    setFixedBgStatus(value) {
        this.isFixedBgOpen = value;
    }
    setHideBgStatus(value) {
        this.hideBgStatus = value;
    }
    updateProgressBar() {
        this.progressBarKey += 1;
    }
    setSkills(skills) {
        this.skills = skills;
    }
    async fetchAccountTitles() {
        try {
            return await AccountApi.fetchAccountTitles();
        }
        catch (e) {
            console.log(e);
        }
        return EMPTY_ACCOUNT_TITLES;
    }
    get isFixedBg() {
        return this.isFixedBgOpen;
    }
    get hideFixedBgStatus() {
        return this.hideBgStatus;
    }
    get subAccountsSaas() {
        return this.accountData.account.sub_accounts;
    }
};
__decorate([
    Mutation
], CommonStore.prototype, "setAccountTitles", null);
__decorate([
    Mutation
], CommonStore.prototype, "setFixedBgStatus", null);
__decorate([
    Mutation
], CommonStore.prototype, "setHideBgStatus", null);
__decorate([
    Mutation
], CommonStore.prototype, "updateProgressBar", null);
__decorate([
    Mutation
], CommonStore.prototype, "setSkills", null);
__decorate([
    Action({ commit: 'setAccountTitles' })
], CommonStore.prototype, "fetchAccountTitles", null);
CommonStore = __decorate([
    Module({
        namespaced: true,
    })
], CommonStore);
export default CommonStore;
